module.exports = __webpack_public_path__ + "img/hanyi.4bf6b0fe.png";